const UpArrow = ({ color = 'black' }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.9982 26.0035L15.9943 5.99641M15.9943 5.99641L10.6078 11.3829M15.9943 5.99641L21.3809 11.3829" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default UpArrow